import { render, staticRenderFns } from "./b-detail-process.vue?vue&type=template&id=2d6c04d4&scoped=true"
import script from "./b-detail-process.vue?vue&type=script&lang=js"
export * from "./b-detail-process.vue?vue&type=script&lang=js"
import style0 from "./b-detail-process.vue?vue&type=style&index=0&id=2d6c04d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6c04d4",
  null
  
)

export default component.exports